import type {BioIconProps} from '../../icons/common-types'
import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'

export default function BestExpertsChoiceLogo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M28.052 9.58675L15.9986 16.5601L3.94531 9.58675C4.47865 8.60008 5.25198 7.73342 6.11865 7.25342L13.2386 3.30675C14.7586 2.45341 17.2386 2.45341 18.7586 3.30675L25.8786 7.25342C26.7453 7.73342 27.5186 8.60008 28.052 9.58675Z"
          fill="#EDEDED"
        />
        <path
          opacity="0.6"
          d="M16.0008 16.56V29.3333C15.0008 29.3333 14.0008 29.12 13.2408 28.6933L6.12083 24.7467C4.5075 23.8533 3.1875 21.6133 3.1875 19.7733V12.2267C3.1875 11.3733 3.48083 10.44 3.9475 9.58667L16.0008 16.56Z"
          fill="#EDEDED"
        />
        <path
          d="M28.8133 12.2267V19.7733C28.8133 21.6133 27.4933 23.8533 25.88 24.7467L18.76 28.6933C18 29.12 17 29.3333 16 29.3333V16.56L28.0533 9.58667C28.52 10.44 28.8133 11.3733 28.8133 12.2267Z"
          fill="#EDEDED"
        />
      </svg>
      <span>Best Experts Choice</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-2 size-7 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
